import Player from "./Player.js";
import InputHandler from "./InputHandler.js";
import Background from "@/digitSkakackaJS/Background";
import BackgroundStatic from "@/digitSkakackaJS/BackgroundStatic";
import Wall from "@/digitSkakackaJS/Wall";
import Tree from "@/digitSkakackaJS/Tree";
import Score from "@/digitSkakackaJS/Score";
import PickUp from "@/digitSkakackaJS/PickUp";
import PowerUp from "@/digitSkakackaJS/PowerUp";
import { Random, MersenneTwister19937} from "random-js";

export default class Game {
    constructor(width, height, sRatioX, sRatioY) {
        this.beforeStartText1 = document.getElementById('text1').textContent
        this.beforeStartText2 = document.getElementById('text2').textContent
        this.beforeStartText2b = document.getElementById('text2b').textContent

        //localStorage.clear()

        this.engine = MersenneTwister19937.autoSeed()
        this.random = new Random(this.engine)

        this.width = width
        this.height = height
        this.sRationX = sRatioX
        this.sRationY = sRatioY
        this.gameStarted = false
        this.gamePaused = false
        this.gameEnded = false
        this.gameSpeed = 0.3

        this.gameEndedWaiting = 8
        this.gameEndedWaitingSpeed = 0.01


        this.input = new InputHandler(this)

        this.player = new Player(this, 100, 300)
        this.listOfWalls = []
        this.listOfWallsTimerMax = 1300
        this.listOfWallsTimerSpeed = 1
        this.listOfWallsTimerProgress = 0
        this.wallColor = "#a49df1"


        let tree = new Tree(this, this.width + 10, 0.8, 1)
        this.listOfWalls.push(tree)

        this.currentTheme = "Starviola"
        this.currentBackground = "Stardark"
        this.listOfPickUps = []
        this.starCountCollectedTohleKolo = 0
        let pickUp = new PickUp(this, 600, height / 2, 'pickupSrdce', 'pickUp')
        this.listOfPickUps.push(pickUp)

        this.backgroundStatic = new BackgroundStatic(this, "#202020")

        this.backgroundPodlaha = new Background(this, 1500, 150, height - 150, 1, "backgroundSnih")

        this.gameRunningTime = 0
        this.srdickaScore = 0
        this.score = new Score(this)
        this.pocetZdiOdOcicek = 0
        this.eyesInGame = false
    }
    resetTheGameToOriginalState() {

    }
    // eslint-disable-next-line no-unused-vars
    update(deltaTime) {
        if (!this.gameStarted && this.input.keys.includes('jump') && this.input.eligibleForUpdate) {
            this.spustitHru()
        }
        if(this.gameStarted && this.gamePaused) {
            //if(this.input.keys.includes('jump') && this.input.eligibleForUpdate) {
            //    this.resetTheGameToOriginalState()
            //    this.input.eligibleForUpdate = false
            //}
            this.gameEndedWaiting -= this.gameEndedWaitingSpeed * deltaTime
            if(this.gameEndedWaiting < 0) {
                this.gameEnded = true
            }
        }
        if(this.gameStarted && !this.gamePaused) {
            this.gameRunningTime += deltaTime / 1000
            this.backgroundPodlaha.update(deltaTime)
            this.player.update(this.input, deltaTime)
            this.generateTree(deltaTime)
            for (let i = 0; i < this.listOfWalls.length; i++) {
                this.listOfWalls[i].update(deltaTime)
            }
            for (let i = 0; i < this.listOfPickUps.length; i++) {
                this.listOfPickUps[i].update(deltaTime)
            }
            this.removeExpiredWalls()
            this.removeExpiredPickUps()
            this.checkKollisionWithTrees()
            this.checkCollisionWithPickUps()
            this.checkCollisionWithStropAPodlaha()
            this.score.update(deltaTime)
        }
    }
    // eslint-disable-next-line no-unused-vars
    draw(context) {
        context.imageSmoothingEnabled = true;
        this.backgroundStatic.draw(context)
        this.player.draw(context)
        for (let i = 0; i < this.listOfWalls.length; i++) {
            this.listOfWalls[i].draw(context)
        }
        this.backgroundPodlaha.draw(context)
        for (let i = 0; i < this.listOfPickUps.length; i++) {
            this.listOfPickUps[i].draw(context)
        }
        this.score.draw(context)

        if(!this.gameStarted) {
            context.fillStyle = "rgba(0,0,0,0.75)"
            context.fillRect(0, 0, this.width, this.height)

            context.textAlign = "center"
            context.font = "800 26px TeleNeoLocalExtraBold"
            //context.strokeStyle = "#FFFFFF"
            //context.lineWidth = 5
            //context.strokeText(this.beforeStartText1, this.width/2, this.height/2)
            context.fillStyle = "#FFFFFF"
            context.fillText(this.beforeStartText1, this.width/2, this.height/2)
            //context.strokeText(this.beforeStartText2, this.width/2, this.height/2 + 24)
            context.fillStyle = "#FFFFFF"
            context.fillText(this.beforeStartText2, this.width/2, this.height/2 + 30)
            context.fillStyle = "#FFFFFF"
            context.fillText(this.beforeStartText2b, this.width/2, this.height/2 + 60)
        }
    }
    spustitHru() {
        this.gameStarted = true
        this.input.eligibleForUpdate = false
    }
    generateTree(deltaTime) {
        this.listOfWallsTimerProgress += this.listOfWallsTimerSpeed * deltaTime
        if(this.listOfWallsTimerProgress > this.listOfWallsTimerMax) {
            console.log(this.height)
            let puvodniNasobekMaly = 6
            let puvodniNasobek = 13
            let puvodniVelikostObr = 889

            let velikostNasobekStart = puvodniNasobekMaly * (this.height / puvodniVelikostObr)
            let velikostNasobek = puvodniNasobek * (this.height / puvodniVelikostObr)

            let maxVelikostMaly = 12 * (this.height / puvodniVelikostObr)
            let maxVelikost = 18 * (this.height / puvodniVelikostObr)

            let randomVariant = this.random.integer(1, 2)
            this.listOfWallsTimerProgress = 0
            if(this.gameRunningTime > 20) {
                velikostNasobekStart = puvodniNasobekMaly * (this.height / puvodniVelikostObr) + (this.gameRunningTime - 20) / 40
                velikostNasobek = puvodniNasobek * (this.height / puvodniVelikostObr) + (this.gameRunningTime - 20) / 40
                this.gameSpeed = 0.3 + (this.gameRunningTime - 20) / 400
                if(this.gameSpeed > 0.4) {
                    this.gameSpeed = 0.4
                }
            }
            if(velikostNasobek > maxVelikost) {
                velikostNasobek = maxVelikost
            }
            if(velikostNasobekStart > maxVelikostMaly) {
                velikostNasobekStart = maxVelikostMaly
            }
            let randomVelikost = this.random.integer(velikostNasobekStart, velikostNasobek)
            randomVelikost /= 10
            let tree = new Tree(this, this.width + 10, randomVelikost, randomVariant)
            this.listOfWalls.push(tree)

            //let maxPoziceSrdickaX = 0
            let maxPoziceSrdickaY = this.height - 200




            let vytvoritEyesChance = 0
            this.pocetZdiOdOcicek++
            if(this.pocetZdiOdOcicek > 15) {
                vytvoritEyesChance = this.random.integer(1, 2)
            } else {
                vytvoritEyesChance = this.random.integer(1, 5)
            }


            if(randomVelikost > 0.9) {
                let randomPosun = this.random.integer(100, 250)
                if(randomVariant == 1) {
                    randomVariant = 2
                }
                let tree2 = new Tree(this, this.width + 10 + randomPosun, randomVelikost - 0.4, randomVariant)
                this.listOfWalls.push(tree2)




                if(vytvoritEyesChance == 1 && this.player.extraLifes <= 0 && !this.eyesInGame && this.pocetZdiOdOcicek > 10) {
                    maxPoziceSrdickaY = tree2.height - 50
                    let poziceY = this.random.integer(this.height - tree.height, maxPoziceSrdickaY)
                    let powerUp = new PowerUp(this, this.width + 250, poziceY, 'eyes', "powerUp")
                    this.eyesInGame = true
                    this.listOfPickUps.push(powerUp)
                } else {
                    maxPoziceSrdickaY = tree2.height - 50
                    let poziceY = this.random.integer(this.height - tree.height, maxPoziceSrdickaY)
                    let pickUp = new PickUp(this, this.width + 250, poziceY, 'pickupSrdce', "pickUp")
                    this.listOfPickUps.push(pickUp)
                }
            } else if(randomVelikost < 0.7) {
                let randomPosun = this.random.integer(100, 250)
                if(randomVariant == 1) {
                    randomVariant = 2
                }
                let tree2 = new Tree(this, this.width + 10 + randomPosun, randomVelikost + 0.3, randomVariant)
                this.listOfWalls.push(tree2)



                if(vytvoritEyesChance == 1 && this.player.extraLifes <= 0 && !this.eyesInGame && this.pocetZdiOdOcicek > 10) {
                    maxPoziceSrdickaY = tree.height - 50
                    let poziceY = this.random.integer(this.height - tree2.height, maxPoziceSrdickaY)
                    let powerUp = new PowerUp(this, this.width + 30, poziceY, 'eyes', "powerUp")
                    this.eyesInGame = true
                    this.listOfPickUps.push(powerUp)
                } else {
                    maxPoziceSrdickaY = tree.height - 50
                    let poziceY = this.random.integer(this.height - tree2.height, maxPoziceSrdickaY)
                    let pickUp = new PickUp(this, this.width + 30, poziceY, 'pickupSrdce', "pickUp")
                    this.listOfPickUps.push(pickUp)
                }
            } else {
                if(vytvoritEyesChance == 1 && this.player.extraLifes <= 0 && !this.eyesInGame && this.pocetZdiOdOcicek > 10) {
                    let poziceY = this.random.integer(this.height - tree.height, maxPoziceSrdickaY)
                    let powerUp = new PowerUp(this, this.width + 225, poziceY, 'eyes', "powerUp")
                    this.eyesInGame = true
                    this.listOfPickUps.push(powerUp)
                } else {
                    let poziceY = this.random.integer(this.height - tree.height, maxPoziceSrdickaY)
                    let pickUp = new PickUp(this, this.width + 225, poziceY, 'pickupSrdce', "pickUp")
                    this.listOfPickUps.push(pickUp)
                }
            }




            /*
            this.pocetZdiOdOcicek++
            let vytvoritPickUpChance = this.random.integer(1, 2)
            console.log(vytvoritPickUpChance)
            let vytvoritEyesChance = 0
            if(this.pocetZdiOdOcicek > 15) {
                vytvoritEyesChance = this.random.integer(1, 2)
            } else {
                vytvoritEyesChance = this.random.integer(1, 5)
            }
            if(vytvoritEyesChance == 1 && this.player.extraLifes <= 0 && !this.eyesInGame && this.pocetZdiOdOcicek > 10) {
                let randomPosition = this.random.integer(1, 100)
                let randomZnamenko = this.random.integer(0, 1)
                if(randomZnamenko == 0) {
                    randomPosition *= (-1)
                }
                let powerUp = new PowerUp(this, this.width + 250, this.height / 2 - 100 + randomPosition, 'eyes', "powerUp")
                this.eyesInGame = true
                this.listOfPickUps.push(powerUp)
            } else if(vytvoritPickUpChance == 1) {
                let randomPosition = this.random.integer(1, 100)
                let randomZnamenko = this.random.integer(0, 1)
                if(randomZnamenko == 0) {
                    randomPosition *= (-1)
                }

                let pickUp = new PickUp(this, this.width + 250, this.height / 2 - 50 + randomPosition, 'pickupSrdce', "pickUp")
                this.listOfPickUps.push(pickUp)
            }
            */




        }
    }
    generateWall(deltaTime) {
        this.listOfWallsTimerProgress += this.listOfWallsTimerSpeed * deltaTime
        if(this.listOfWallsTimerProgress > this.listOfWallsTimerMax) {
            this.listOfWallsTimerProgress = 0
            let gapPositionStart = this.random.integer(10, 60)
            let gapSize = this.random.integer(200, 350)
            let wall = new Wall(this, this.width + 10, gapPositionStart, gapSize, this.wallColor)
            this.listOfWalls.push(wall)
            this.pocetZdiOdOcicek++
            let vytvoritPickUpChance = this.random.integer(1, 2)
            let vytvoritEyesChance = 0
            if(this.pocetZdiOdOcicek > 15) {
                vytvoritEyesChance = this.random.integer(1, 2)
            } else {
                vytvoritEyesChance = this.random.integer(1, 5)
            }
            if(vytvoritEyesChance == 1 && this.player.extraLifes <= 0 && !this.eyesInGame && this.pocetZdiOdOcicek > 10) {
                let randomPosition = this.random.integer(1, 100)
                let randomZnamenko = this.random.integer(0, 1)
                if(randomZnamenko == 0) {
                    randomPosition *= (-1)
                }
                let powerUp = new PowerUp(this, this.width + 200, this.height / 2 + randomPosition, 'eyes', "powerUp")
                this.eyesInGame = true
                this.listOfPickUps.push(powerUp)
            } else if(vytvoritPickUpChance == 1) {
                let randomPosition = this.random.integer(1, 100)
                let randomZnamenko = this.random.integer(0, 1)
                if(randomZnamenko == 0) {
                    randomPosition *= (-1)
                }

                let pickUp = new PickUp(this, this.width + 200, this.height / 2 + randomPosition, 'pickupSrdce', "pickUp")
                this.listOfPickUps.push(pickUp)
            }
        }
    }
    removeExpiredWalls() {
        let indexesToErase = []
        for (let i = 0; i < this.listOfWalls.length; i++) {
            if(this.listOfWalls[i].readyToDestroy) {
                indexesToErase.push(i)
            }
        }
        if(indexesToErase.length > 0) {
            this.listOfWalls.splice(indexesToErase[0], 1);
        }
    }
    checkKollisionWithTrees() {
        if(!this.player.immortality) {
            for (let i = 0; i < this.listOfWalls.length; i++) {
                if(this.checkCollisionWithTriangle(
                        this.listOfWalls[i].x,
                        this.listOfWalls[i].y,
                        this.listOfWalls[i].width,
                        this.listOfWalls[i].height)
                ) {
                    if(this.player.extraLifes <= 0) {
                        this.gamePaused = true
                    } else {
                        this.player.extraLifes--
                        this.player.immortality = true
                        this.pocetZdiOdOcicek = 0
                        if(this.backgroundStatic.color != "#FFFFFF") {
                            this.player.changeImage('digitVanoce')
                        } else {
                            this.player.changeImage('digitVanoce')
                        }
                    }

                }
            }
        }
    }
    checkKollisionWithWalls() {
        if(!this.player.immortality) {
            for (let i = 0; i < this.listOfWalls.length; i++) {
                if(this.checkCollisionWithWallBody(
                        this.listOfWalls[i].x,
                        0,
                        this.listOfWalls[i].width,
                        this.listOfWalls[i].gapYStart) ||
                    this.checkCollisionWithWallBody(
                        this.listOfWalls[i].x,
                        this.listOfWalls[i].gapYEnd,
                        this.listOfWalls[i].width,
                        this.height) ||
                    this.checkCollisionWithTriangle(
                        this.listOfWalls[i].x,
                        this.listOfWalls[i].gapYStart,
                        this.listOfWalls[i].width,
                        this.listOfWalls[i].height,
                        this.listOfWalls[i].gapYEnd)
                ) {
                    if(this.player.extraLifes <= 0) {
                        this.gamePaused = true
                    } else {
                        this.player.extraLifes--
                        this.player.immortality = true
                        this.pocetZdiOdOcicek = 0
                        if(this.backgroundStatic.color != "#FFFFFF") {
                            this.player.changeImage('digitwhite')
                        } else {
                            this.player.changeImage('digitdark')
                        }
                    }

                }
            }
        }
    }
    removeExpiredPickUps(){
        let indexesToErase = []
        for (let i = 0; i < this.listOfPickUps.length; i++) {
            if(this.listOfPickUps[i].readyToDestroy) {
                indexesToErase.push(i)
                if(this.listOfPickUps[i].type == 'powerUp') {
                    this.eyesInGame = false
                } else {
                    if(this.listOfPickUps[i].missedItem == true) {
                        //this.srdickaScore--
                    }
                }
            }
        }
        if(indexesToErase.length > 0) {
            this.listOfPickUps.splice(indexesToErase[0], 1);
        }
    }
    checkCollisionWithPickUps() {
        for(let i = 0; i < this.listOfPickUps.length; i++) {
            const a = this.listOfPickUps[i].collisionOriginX - this.player.collisionOriginX
            const b = this.listOfPickUps[i].collisionOriginY - this.player.collisionOriginY
            const distanceOdPickUpu = Math.sqrt(a * a + b * b)
            if(distanceOdPickUpu <= this.listOfPickUps[i].colisionRadius + this.player.colisionRadius) {
                this.listOfPickUps[i].readyToDestroy = true
                if(this.listOfPickUps[i].type == 'pickUp') {
                    this.srdickaScore++
                } else if(this.listOfPickUps[i].type == 'powerUp') {
                    this.player.extraLifes++
                    this.eyesInGame = false
                    if(this.backgroundStatic.color != "#FFFFFF") {
                        this.player.changeImage('digitVanoceOci')
                    } else {
                        this.player.changeImage('digitVanoceOci')
                    }
                }
            }
        }
    }

    checkCollisionWithStropAPodlaha() {
        if(this.player.y <= 0 - this.player.height / 2) {
            this.gamePaused = true
        } else if(this.player.y + this.player.height * this.player.scale >= this.height) {
            this.gamePaused = true
        }
    }




    //Pomocne funkce
    checkCollision(circle, triangle) {
        function pointInCircle(px, py, cx, cy, r) {
            return Math.sqrt((px - cx) ** 2 + (py - cy) ** 2) <= r;
        }

// Kontrola vzdálenosti bodu k úsečce
        function pointToSegmentDistance(px, py, ax, ay, bx, by) {
            const t = Math.max(0, Math.min(1, ((px - ax) * (bx - ax) + (py - ay) * (by - ay)) / ((bx - ax) ** 2 + (by - ay) ** 2)));
            const nearestX = ax + t * (bx - ax);
            const nearestY = ay + t * (by - ay);
            return Math.sqrt((px - nearestX) ** 2 + (py - nearestY) ** 2);
        }

        const { x: cx, y: cy, radius: r } = circle;
        const { A, B, C } = triangle;

        // Kontrola, zda je některý vrchol trojúhelníku uvnitř kruhu
        if (pointInCircle(A.x, A.y, cx, cy, r) ||
            pointInCircle(B.x, B.y, cx, cy, r) ||
            pointInCircle(C.x, C.y, cx, cy, r)) {
            return true;
        }

        // Kontrola, zda některá hrana trojúhelníku protíná kruh
        if (pointToSegmentDistance(cx, cy, A.x, A.y, B.x, B.y) <= r ||
            pointToSegmentDistance(cx, cy, B.x, B.y, C.x, C.y) <= r ||
            pointToSegmentDistance(cx, cy, C.x, C.y, A.x, A.y) <= r) {
            return true;
        }

        return false;
    }
    checkCollisionWithTriangle(treeX, treeY, treeWidth, treeHeight) {

        const circle = { x: this.player.collisionOriginX, y: this.player.collisionOriginY, radius: this.player.colisionRadius }
        const triangle = {
            A: { x: treeX, y: treeY + treeHeight },
            B: { x: treeX + treeWidth, y: treeY + treeHeight },
            C: { x: treeX + treeWidth / 2, y: treeY }
        }


        if (this.checkCollision(circle, triangle)) {
            return true
        } else {
            return false
        }
    }
    checkCollisionWithWallBody(rectangleX, rectangleY, rectangleWidth, rectangleHeight) {


        let nejblizsiX = Math.max(rectangleX, Math.min(this.player.collisionOriginX, rectangleX + rectangleWidth));
        let nejblizsiY = Math.max(rectangleY, Math.min(this.player.collisionOriginY, rectangleY + rectangleHeight));


        let distanceX = this.player.collisionOriginX - nejblizsiX;
        let distanceY = this.player.collisionOriginY - nejblizsiY;


        let vzdalenostVypocet = (distanceX * distanceX) + (distanceY * distanceY);


        if(vzdalenostVypocet < (this.player.colisionRadius * this.player.colisionRadius)) {
            return true
        } else {
            return false
        }
    }
}